// import {log} from "@/api/response" //请求后端做记录

const state = {
    downLoadStatus: {
        data: {},
        show: false,
    },
    // userMenu: {},
};

const mutations = {
    setDownLoad(state, data) {
        console.log(data, "55555")
        if (!data) {
            state.downLoadStatus.data = {};
            state.downLoadStatus.show = false;
        } else {
            if (state.downLoadStatus.data.hasOwnProperty(data.id)) {
                state.downLoadStatus.data[data.id] = { ...state.downLoadStatus.data[data.id], ...data };
            } else {
                state.downLoadStatus.data[data.id] = data;
            }
            state.downLoadStatus.show = true;
            if (state.downLoadStatus.data[data.id].downState == "100.00%") {
                delete state.downLoadStatus.data[data.id]
            }
            if (Object.keys(state.downLoadStatus.data).length == 0) {
                state.downLoadStatus.show = false
            }
            state.downLoadStatus.data = Object.assign({}, state.downLoadStatus.data)
            // var json = {
            //   ...data,
            // };
            // state.userList = json;
        }

        // log(json).then((res)=>{
        //     console.log(res)
        //   }).catch(err => {
        //       // 报错
        //       console.log(err)
        //     })
    },
    setupdateDownLoad(state, data) {
        console.log(data, "55555")
        if (!data) {

        } else {
            if (data.type == "stop") {

                state.downLoadStatus.data[data.id].pass = !state.downLoadStatus.data[data.id].pass;
                if (state.downLoadStatus.data[data.id].pass) {
                    // if (state.downLoadStatus.data[data.id].download.hasOwnProperty("pauseDownload")) {
                    state.downLoadStatus.data[data.id].download.pauseDownload()
                    // }
                } else {
                    // if (state.downLoadStatus.data[data.id].download.hasOwnProperty("resumeDownload")) {
                    state.downLoadStatus.data[data.id].download.resumeDownload()
                    // }
                }
            } else if (data.type == "clear") {
                // if (state.downLoadStatus.data[data.id].download.hasOwnProperty("cancelDownload")) {
                state.downLoadStatus.data[data.id].download.cancelDownload()
                // }
                delete state.downLoadStatus.data[data.id];
                state.downLoadStatus.data = Object.assign({}, state.downLoadStatus.data)
            }
        }

        // log(json).then((res)=>{
        //     console.log(res)
        //   }).catch(err => {
        //       // 报错
        //       console.log(err)
        //     })
    },
    // setUserMenu(state, data) {
    //   if (!data) {
    //     state.userMenu = {};
    //   } else {
    //     var json = {
    //       ...data,
    //     };
    //     state.userMenu = json;
    //   }
    // },
};

const actions = {};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
